export const parsePlaceDetails = (placeDetails) => {
  const getLongNameForType = (type) =>
    placeDetails.address_components.find(({ types }) => types.includes(type))?.long_name;

  return {
    city: getLongNameForType('locality'),
    postalCode: getLongNameForType('postal_code'),
    country: getLongNameForType('country'),
    number: getLongNameForType('street_number'), // street number
    street: getLongNameForType('route'),
    state: getLongNameForType('administrative_area_level_1'),
  };
};

export const getFullAddressName = (location, showInvalid = true) => {
  if (!location || Object.values(location).every((el) => !el)) {
    return '';
  }

  const { number, street, city, state, postalCode, country } = location;
  const invalidText = showInvalid ? 'invalid' : '';

  return [
    ...[number, street],
    ...[city, state, postalCode].map((el) => el || invalidText),
    ...[country].map((el) => el || invalidText),
  ]
    .filter(Boolean)
    .join(', ');
};
